import apiClient from "./axios.config";

const ownersReset = {
  resetPassword: async (resetId, otp, password) => {
    try {
      const response = await apiClient.post("/owner/reset-password", {
        resetId,
        otp,
        pwd: password,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  resendOtp: async (ownerData) => {
    try {
      const { resetId } = ownerData;
      const response = await apiClient.post(
        `/owner/reset/resend-otp/${resetId}`
      );
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default ownersReset;
